import React from 'react';
import EditIcon from "@mui/icons-material/Edit";

const EditIconRenderer = (params) => (
    <div>
      <EditIcon 
        onClick={(e) => {
         editDetails(e, params);
        }}
        />
      </div>
    );
export default EditIconRenderer;